import { render } from "./EmployeeEdit.vue?vue&type=template&id=45bdd196&ts=true"
import script from "./EmployeeEdit.vue?vue&type=script&lang=ts"
export * from "./EmployeeEdit.vue?vue&type=script&lang=ts"

import "./EmployeeEdit.vue?vue&type=style&index=0&id=45bdd196&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__